enum EBillingPendencyPeriod {
  DUE = 'DUE',
  OVERDUE = 'OVERDUE',
}

export default EBillingPendencyPeriod;
